import io from 'socket.io-client';
import uuid from 'uuid';
import {store} from '../index';
import {setError} from '../actions';

const SERVER_URL_AUTH = process.env.NODE_ENV === 'development' ? 'https://adspromote.ru:8003' : 'https://adspromote.ru:8002';
const SERVER_URL = process.env.NODE_ENV === 'development' ? 'https://adspromote.ru:8003' : 'https://adspromote.ru:8002';
const OPERATION_MODIFY = 'modify';
const OPERATION_CREATE = 'create';
const OPERATION_REMOVE = 'delete';
const USER_URI = 'admin/users';
const GROUP_URI = 'admin/groupusers';
const ACCESS_URI = 'admin/useraccess';
const CHANGE_PASSWORD_URI = 'admin/userpasswd';
const CHANGE_TOKEN_URI = 'admin/usertoken';


let socket;
let context;
const headers = {};

//context - это ссылка на активный компонент App, который содержит существующий компонент loader.
//Через эту ссылку можно управлять отображением лоадера, вызывая методы showLoader() и hideLoader()
function setContext(ctx){
    context = ctx;
}

function connect(uri) {
  socket = io.connect(uri, { transports: ['websocket'] });
  return socket;
}

function setHeader(name, value) {
  headers[name] = value;
}

function socketFetch(route, params, res, ack) {
  const channel = `${route}/channel/${Date.now()}`;
  const req = { channel, headers, params };
  socket.on(channel, res);
  return socket.emit(route, req, (...args) => {
    socket.off(channel);
    if (ack) {
      ack(...args);
    }
  });
}

function sendChange(opt){
    console.log(context);
    if(context){
        context.showLoader();
    }
  let objForSend = {
      operation: opt.operation,
      operationId: uuid.v4(),
      modified: new Date(),
      payload: opt.data,
  };
  if(opt.data){
      objForSend.payload = opt.data;
  }
  if(opt.id){
      objForSend.id = opt.id;
  }
  console.log(opt);
    console.log('before call socketFetch');
  socketFetch(opt.uri, objForSend,
      res=>{
          console.log(res);
      },
      res => {
          if(context){
              context.hideLoader();
          }
          if(res && res.error){
              console.log(res);
              if(res.error.code === 11000){
                  store.dispatch(setError("Пользователь с таким логином уже существует!"));
              } else if(res.error === 'duplicate date'){
                  store.dispatch(setError("Доступ с указанными данными уже существует!"));
              } else if(res.error === 'promoter not found'){
                  store.dispatch(setError("Пользователь не найден!"));
              } else if(res.error === 'unauthorized'){
                  window.localStorage.removeItem('token');
                  console.log('remove token');
                  window.location.href = window.location.href;
              }
              if(opt.fail) {
                  console.log('fail');
                  opt.fail();
              }
          } else if(opt.success){
              console.log('success');
              opt.success();
          }
  });
}

export default {
  connect,
  setHeader,
  socketFetch,
    setContext,
    sendChange,
    SERVER_URL,
    SERVER_URL_AUTH,
    OPERATION_CREATE,
    OPERATION_MODIFY,
    OPERATION_REMOVE,
    USER_URI,
    GROUP_URI,
    ACCESS_URI,
    CHANGE_PASSWORD_URI,
    CHANGE_TOKEN_URI
};



// WEBPACK FOOTER //
// ./src/utils/socket-client.js